<form [formGroup]="htmlForm!" novalidate>
    <editor
        apiKey="x7ek8y038q71miieruxssynb2plbuqp4kfd0fmpkfltgok7n"
        cloudChannel="7"
        [disabled]="false"
        id=""
        [init]= "editorConfig"
        initialValue=""
        [inline]="false"
        plugins=""
        tagName="div"
        toolbar=""
        formControlName="html"
        [(ngModel)]="html"
        selector="textarea"
    ></editor>
</form>
